import { map } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';
import styles from './style.m.less';

const propTypes = {
    page: PropTypes.number.isRequired,
    children: PropTypes.any.isRequired,
    height: PropTypes.number.isRequired,
};

export default class SlideShow extends Component {
    render() {
        const { page, children, height } = this.props;

        return (
            <div className={styles.container} style={{ minHeight: height }}>
                <div
                    className={styles.slider}
                    style={{
                        transform: `translate3d(${-page * 100}%, 0, 0)`,
                    }}
                >
                    {renderItems(children)}
                </div>
            </div>
        );
    }
}

function renderItems(items) {
    return map(items, (component, i) => <Item key={i}>{component}</Item>);
}

function Item({ children }) {
    return <div className={styles.item}>{children}</div>;
}

SlideShow.propTypes = propTypes;
